import getRuntimeConstants from "../../runtimeConstants";
import {
  addToWishlistTemplate,
  notifyMeButtonClickTemplate,
  pageLoadMixAndMatchTemplate,
  pageLoadSingleProductTemplate,
  addToCartSingleProductTemplate,
  addToCartMultipleProductTemplate,
  viewItemListTemplate,
  productComponentImpressionTemplate,
  mspOnboardingCompletedTemplate,
  mspRecommendationDisplayedTemplate,
  mspSizeSelectedTemplate,
} from "./marketingTrackingTemplates";
import { pushToDataLayer } from "../../utils/pushToDataLayer";
import getWindow from "../window";

export const fireSaveForLaterMarketing = ({
  product,
  variantsAdded,
  component_name = "pdp_hero",
}) => {
  pushToDataLayer(
    addToWishlistTemplate({
      product,
      variantsAdded,
      component_name,
    }),
  );
};

export const fireAddToBagMarketing = ({
  products,
  variantsAddedList,
  context = "pdp_hero",
}) => {
  const { isMixAndMatch } = getRuntimeConstants();

  if (variantsAddedList.length < 1 || !products) {
    return;
  }

  const requestId =
    context === "pdp_hero" ? getWindow()?.s?.eVar231 || null : undefined;

  if (isMixAndMatch && variantsAddedList.length > 1) {
    pushToDataLayer(
      addToCartMultipleProductTemplate({
        products,
        variantsAddedList,
        context,
        requestId,
      }),
    );
    return;
  }

  pushToDataLayer(
    addToCartSingleProductTemplate({
      products,
      variantAdded: variantsAddedList[0],
      context,
      requestId,
    }),
  );
};

export const firePageLoadMarketing = async ({ products }) => {
  const { isMixAndMatch, hostAndPath, urlParams } = getRuntimeConstants();

  if (!products) {
    return;
  }

  const requestId = getWindow()?.s?.eVar231 || null;
  const config = { hostAndPath, urlParams, requestId };
  if (isMixAndMatch) {
    pushToDataLayer({
      view_item: pageLoadMixAndMatchTemplate(products, config),
    });
    return;
  }

  // For single product, ensure products has variants before firing
  // Variants can be empty after filtering if they don't have prices
  if (!products.variants || !products.variants.length) {
    return;
  }

  pushToDataLayer({
    view_item: pageLoadSingleProductTemplate(products, config),
  });
};

export const fireNotifyMeButtonClickMarketing = ({
  product,
  variant,
  component_name = "pdp_hero",
  isAppDownloadNudgeShown = false,
}) => {
  pushToDataLayer(
    notifyMeButtonClickTemplate({
      product,
      variant,
      component_name,
      isAppDownloadNudgeShown,
    }),
  );
};

export const fireViewItemListMarketing = ({
  products,
  listName,
  recsRequestId,
}) => {
  if (!products || !products.length) {
    return;
  }

  const templateData = {
    products,
    listName,
  };

  if (typeof recsRequestId === "string" && recsRequestId.length > 0) {
    templateData.recsRequestId = recsRequestId;
  }

  pushToDataLayer(viewItemListTemplate(templateData));
};

export const fireProductComponentImpression = ({
  products,
  itemListName,
  row = undefined,
}) => {
  if (!products || !products.length) {
    return;
  }

  pushToDataLayer(
    productComponentImpressionTemplate({
      products,
      itemListName,
      row,
    }),
  );
};

export const fireSponsoredYmalLoadMarketing = ({
  products,
  listName = "pdp_ymal",
}) => {
  if (!products || !products.length) {
    return;
  }

  const sponsoredProducts = products.filter((product) => product.advertisement);

  if (!sponsoredProducts.length) {
    return;
  }

  const adPositions = [];
  products.forEach((product, index) => {
    if (product.advertisement) {
      adPositions.push(index);
    }
  });

  const adProducts = sponsoredProducts.map(
    (product) =>
      product.advertisement?.ProductName ||
      product.productTitle ||
      product.name,
  );

  const adCount = adProducts.length;

  const payload = viewItemListTemplate({
    products,
    listName,
    includeSponsoredMetadata: true,
  });

  payload.view_item_list.has_sponsored_ads = true;
  payload.view_item_list.ad_positions = adPositions;
  payload.view_item_list.ad_products = adProducts;
  payload.view_item_list.ad_count = adCount;

  pushToDataLayer(payload);
};

export const fireSponsoredYmalInViewMarketing = ({
  products,
  listName = "pdp_ymal",
}) => {
  fireSponsoredYmalLoadMarketing({ products, listName });
};

export const fireMspOnboardingCompleted = ({ product }) => {
  pushToDataLayer(mspOnboardingCompletedTemplate({ product }));
};

export const fireMspRecommendationDisplayed = ({
  product,
  recommendedSizeCount,
}) => {
  pushToDataLayer(
    mspRecommendationDisplayedTemplate({ product, recommendedSizeCount }),
  );
};
export const fireMspSizeSelected = ({ product, isRecommended }) => {
  pushToDataLayer(mspSizeSelectedTemplate({ product, isRecommended }));
};
